import type { DataIngestionEntityDtoResponse } from '@asset-metrix/portal-gateway-client-js';

import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const getDataIngestionEntities = async (
  contentId: string
): Promise<DataIngestionEntityDtoResponse> => {
  const response =
    await portalGatewayClient.table.getDataIngestionEntities(contentId);

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(
        response.error,
        'Error loading data ingestion entities.'
      ),
      response
    );
  }

  return response.data;
};
